import '../pages.css';
import { Link } from 'react-router-dom';

const CastPartial = () => {
    return (
        <div className="page product-detail">
            <section className="product-detail-hero">
                <div className="product-detail-hero-content">
                    <Link to="/products/removable" className="back-link">← Back to Removable Prosthetics</Link>
                    <h1>Cast Partial</h1>
                    <p className="product-tagline">Durability meets comfort and functional stability</p>
                </div>
            </section>

            <section className="product-detail-content">
                <div className="content-container">
                    <div className="product-section">
                        <h2>Description</h2>
                        <p>
                            Cast partial dentures from <strong>AbELab</strong> are designed to provide durability, comfort, and functional
                            stability for partially edentulous patients. These restorations combine a flexible Valplast® acrylic base with
                            a rigid metal framework, offering both strength and adaptability. The Valplast® material is a biocompatible nylon
                            thermoplastic that allows for enhanced esthetics, reduced bulk, and increased patient comfort while minimizing the
                            risk of acrylic-related allergies. The framework can be fabricated using chromium-cobalt or Vitallium® 2000 alloy
                            to meet specific clinical needs.
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CastPartial;
